import axios from '@/axios.js'

export default {
    getStyleList: async (versionUuid) => {
        const response = await axios.editorapi.get(`/v4/app-configurator/styles`, { params: {q: `version_uuid:${versionUuid}` }})
        return response.data.object
    },
    getTemplateList: async () => {
        const response = await axios.editorapi.get(`/v4/app-configurator/styles-templates`)
        return response.data.object
    },
    getStyle: async (uuid) => {
        const response = await axios.editorapi.get(`/v4/app-configurator/styles/${uuid}`)
        return response.data.object
    },
    editStyle: async (style) => {
        const response = await axios.editorapi.patch(`/v4/app-configurator/styles/${style.uuid}`, {
            name: style.name,
            values: JSON.stringify(style.values),
            timeofyear: style.timeOfYear,
        })

        return response.data
    },
    createStyle: async(style) => {
        const response = await axios.editorapi.post(`/v4/app-configurator/styles/${style.uuid}`, {
            name: style.name,
            values: JSON.stringify(style.values),
            timeofyear: style.timeOfYear,
            version_uuid: style.version_uuid,
            styles_template_uuid: style.styles_template_uuid
        })

        return response.data
    },
    deleteStyle: async(uuid) => {
        const response = await axios.editorapi.delete(`/v4/app-configurator/styles/${uuid}`)
        return response.data
    }
}
